import useDraft from "../../core/useDraft";
import { PostFormData } from "../../../types/features/Post";

export default function usePostForm(initialData?: any) {
  const defaultData: PostFormData = {
    title: "",
    title_en: "",
    excerpt: "",
    excerpt_en: "",
    content: "",
    content_en: "",
    featured_image: null,
    tags: [],
    status: "draft",
    published_at: null,
    seo_title: null,
    seo_description: null,
    product_name: "blog",
    product_name_en: "blog",
  };

  const draft = useDraft<PostFormData>(
    initialData ? {
      title: initialData.title,
      title_en: initialData.title_en,
      excerpt: initialData.excerpt || "",
      excerpt_en: initialData.excerpt_en || "",
      content: initialData.content || "",
      content_en: initialData.content_en || "",
      featured_image: initialData.featured_image || null,
      tags: initialData.tags || [],
      status: initialData.status || "draft",
      published_at: initialData.published_at || null,
      seo_title: initialData.seo_title || null,
      seo_description: initialData.seo_description || null,
      product_name: initialData.product_name || "blog",
      product_name_en: initialData.product_name_en || "blog",
    } : defaultData,
    {
      storageKey: `post_draft_${initialData?.id || 'new'}`,
      autoSaveDelay: 3000,
    }
  );

  return draft;
}